import React from 'react';
import { Link } from 'react-router-dom';

import useInView from '../../hooks/useInView';  // Updated import path
import servicenow from '../images/servicenows-cloud-based-solutions-power-the-service-circle-11563041318u9zqmrhmms-removebg-preview.png';

const ServiceNowMigration = () => {
  const [overviewRef, overviewInView] = useInView();
  const [journeyRef, journeyInView] = useInView();
  const [capabilitiesRef, capabilitiesInView] = useInView();
  const [whyChooseRef, whyChooseInView] = useInView();

  return (
    <div className="servicenow-migration-page">
      {/* Hero Section - Animates on load */}
      <section className="quantum-migration-showcase">
        <div className="nexus-quantum-container">
          <div className="nexus-hero-content">
            <div className="hero-text">
              <h1>Enterprise ServiceNow Migration</h1>
              <p className="nexus-hero-subtitle">Seamless transition to ServiceNow with zero business disruption</p>
            </div>
            <div className="hero-cta">
              <Link to="/contact" className="quantum-cta-nexus">
                Get a Free Consultation
                <span className="nexus-cta-arrow">→</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Overview Section */}
      <section 
        ref={overviewRef} 
        className={`sn-migration-hero ${overviewInView ? 'animate' : ''}`}
      >
        <div className="sn-container">
          <div className="sn-header">
            <h1 className="sn-title"data-aos="fade-up" data-aos-delay="400">Transform Your Business with ServiceNow</h1>

          </div>
          
          <div className="sn-content-grid">
            <div className="sn-text-content">
              <p className="sn-description">
                Cognifyar Technologies provides end-to-end ServiceNow migration services that help organizations modernize their IT service management, 
                customer service, HR service delivery, and business operations. Our certified ServiceNow architects and developers ensure your migration 
                is executed with precision, minimal downtime, and maximum ROI.
              </p>
              
              <ul className="sn-benefits-list">
                <li className="sn-benefit">Proven migration methodologies with 100% success rate</li>
                <li className="sn-benefit">Minimal business disruption during transition</li>
                <li className="sn-benefit">Customized migration strategy for your unique needs</li>
                <li className="sn-benefit">Post-migration optimization and support</li>
              </ul>
            </div>
            
            <div className="sn-image-wrapper">
              <img src={servicenow} alt="ServiceNow Migration Process" className="sn-feature-image" />
            </div>
          </div>
        </div>
      </section>

      {/* Migration Journey Section */}
      <section 
        ref={journeyRef} 
        className={`sn-migration-journey ${journeyInView ? 'animate' : ''}`}
      >
        <div className="sn-container">
          <div className="sn-section-intro">
            <h2 className="sn-section-title">Our Proven Migration Approach</h2>
            <p className="sn-section-lead">A structured methodology for successful ServiceNow implementation</p>
          </div>
          
          <div className="sn-process-flow">
            <div className="sn-process-step">
              <div className="sn-step-marker">
                <span className="sn-step-number">1</span>
                <div className="sn-step-connector"></div>
              </div>
              <div className="sn-step-content">
                <h3 className="sn-step-title">Assessment & Planning</h3>
                <p className="sn-step-desc">Comprehensive analysis of your current environment and creation of a detailed migration roadmap</p>
              </div>
            </div>
            
            <div className="sn-process-step">
              <div className="sn-step-marker">
                <span className="sn-step-number">2</span>
                <div className="sn-step-connector"></div>
              </div>
              <div className="sn-step-content">
                <h3 className="sn-step-title">Data Migration</h3>
                <p className="sn-step-desc">Secure transfer of configuration items, user data, and historical records with data integrity checks</p>
              </div>
            </div>
            
            <div className="sn-process-step">
              <div className="sn-step-marker">
                <span className="sn-step-number">3</span>
                <div className="sn-step-connector"></div>
              </div>
              <div className="sn-step-content">
                <h3 className="sn-step-title">Customization & Integration</h3>
                <p className="sn-step-desc">Tailoring ServiceNow to your business needs and integrating with existing systems</p>
              </div>
            </div>
            
            <div className="sn-process-step">
              <div className="sn-step-marker">
                <span className="sn-step-number">4</span>
                <div className="sn-step-connector"></div>
              </div>
              <div className="sn-step-content">
                <h3 className="sn-step-title">Testing & Validation</h3>
                <p className="sn-step-desc">Rigorous testing of all migrated components to ensure functionality and performance</p>
              </div>
            </div>
            
            <div className="sn-process-step">
              <div className="sn-step-marker">
                <span className="sn-step-number">5</span>
                <div className="sn-step-connector"></div>
              </div>
              <div className="sn-step-content">
                <h3 className="sn-step-title">Deployment & Training</h3>
                <p className="sn-step-desc">Smooth go-live transition and comprehensive user training for adoption</p>
              </div>
            </div>
            
            <div className="sn-process-step">
              <div className="sn-step-marker">
                <span className="sn-step-number">6</span>
              </div>
              <div className="sn-step-content">
                <h3 className="sn-step-title">Optimization</h3>
                <p className="sn-step-desc">Continuous improvement and refinement post-migration</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Capabilities Section */}
      <section 
        ref={capabilitiesRef} 
        className={`section capabilities-section ${capabilitiesInView ? 'animate' : ''}`}
      >
        <div className="container">
          <div className="sn-section-intro">
            <h2 className="sn-section-title">Our ServiceNow Migration <br></br>Capabilities</h2>
          </div>
          <div className="capabilities-grid">
            <div className="capability cyberpunk-card">
              <div className="capability-icon">
                <i className="fas fa-sync-alt spin-3d"></i>
              </div>
              <h3>Platform Evolution</h3>
              <p>Modernize from legacy systems with AI-assisted workflow conversion and automated testing</p>
              <div className="cyber-line"></div>
            </div>
            
            <div className="capability cyberpunk-card">
              <div className="capability-icon">
                <i className="fas fa-cloud-moon-rain meteor-fall"></i>
              </div>
              <h3>Cloud Acceleration</h3>
              <p>Hyper-scale cloud transition with built-in security protocols and compliance automation</p>
              <div className="cyber-line"></div>
            </div>
            
            <div className="capability cyberpunk-card">
              <div className="capability-icon">
                <i className="fas fa-brain circuit-pulse"></i>
              </div>
              <h3>Smart Data Transfer</h3>
              <p>Neural network-powered data migration with self-healing mapping and integrity checks</p>
              <div className="cyber-line"></div>
            </div>
            
            <div className="capability cyberpunk-card">
              <div className="capability-icon">
                <i className="fas fa-robot hover-float"></i>
              </div>
              <h3>App <br></br>Modernization</h3>
              <p>Legacy script transformation with AI code optimization and platform-native rebuilds</p>
              <div className="cyber-line"></div>
            </div>
            
            <div className="capability cyberpunk-card">
              <div className="capability-icon">
                <i className="fas fa-plug bolt-flicker"></i>
              </div>
              <h3>API<br></br> Ecosystem</h3>
              <p>Next-gen integration fabric with real-time monitoring and predictive failure analysis</p>
              <div className="cyber-line"></div>
            </div>
            
            <div className="capability cyberpunk-card">
              <div className="capability-icon">
                <i className="fas fa-rocket launch-sequence"></i>
              </div>
              <h3>Release <br></br>Hyperdrive</h3>
              <p>Automated version leap with impact simulation and feature adoption forecasting</p>
              <div className="cyber-line"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section 
        ref={whyChooseRef} 
        className={`section why-choose-section ${whyChooseInView ? 'animate' : ''}`}
      >
        <div className="container">
          <h2>Why Choose Cognifyar for ServiceNow Migration?</h2>
          <div className="advantages-grid">
            <div className="advantages-row">
              <div className="advantage-card">
                <h3>Certified Experts</h3>
                <div className="divider"></div>
                <p>ServiceNow Certified Implementation Specialists and Architects deliver migrations aligned with platform best practices and enterprise requirements.</p>
              </div>
              <div className="advantage-card">
                <h3>Proven Methodology</h3>
                <div className="divider"></div>
                <p>A standardized 6-phase migration framework mitigates risks through comprehensive discovery, validation, and cutover planning.</p>
              </div>
            </div>
            <div className="advantages-row">
              <div className="advantage-card">
                <h3>Minimal Downtime</h3>
                <div className="divider"></div>
                <p>A standardized 6-phase migration framework mitigates risks through comprehensive discovery, validation, and cutover planning.</p>
              </div>
              <div className="advantage-card">
                <h3>ROI Focused</h3>
                <div className="divider"></div>
                <p>Strategic workflow prioritization typically yields measurable efficiency gains within the first quarter post-implementation.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container">
          <h2>Ready to Migrate to ServiceNow?</h2>
          <p>Let our experts guide you through a seamless transition to the Now Platform</p>
          <div className="cta-buttons">
            <Link to="/contact" className="cta-button primary">Start Your Migration</Link>
            {/* <Link to="/contact" className="cta-button secondary">Request a Demo</Link> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceNowMigration;